import { graphql } from 'gatsby';
import React, { useState } from 'react';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
const ModularHeadingImageDropdownTableBox = ({ data }) => {
  const [showDropdownBody, setShowDropdownBody] = useState();
  const {
    backgroundColor,
    dropdownBody,
    image,
    noBottomPadding,
    noTopPadding,
    secondaryImage,
    tables,
    heading,
  } = data;

  return (
    <div
      className={`modular-heading-image-dropdown-table-box-container ${backgroundColor} ${
        noBottomPadding && 'modular-padding-large-no-bottom'
      } ${noTopPadding && 'modular-padding-large-no-top'} ${
        !noBottomPadding && !noBottomPadding && 'modular-padding-large'
      } `}
    >
      <div className="modular-box-container White">
        {' '}
        <div className="image-content">
          <div className="image">
            <LitImage image={image} />
          </div>{' '}
          <div className="content">
            <LitStructuredText data={heading} basic />

            <button
              onClick={() => setShowDropdownBody(!showDropdownBody)}
              className={`button ${
                showDropdownBody ? 'collapsed' : 'un-collapsed'
              }`}
            >
              {' '}
              <LitStructuredText data={dropdownBody} />{' '}
              <FontAwesomeIcon icon={faArrowDown} />
            </button>
          </div>
        </div>
        {showDropdownBody && (
          <div className="image-tables">
            <div className="tables">
              {tables.map(
                (
                  { heading, tableHeadingOne, tableHeadingTwo, tables },
                  index,
                ) => {
                  return (
                    <div className="table-container" key={index}>
                      <LitStructuredText data={heading} basic />
                      <table>
                        <tr className="Yellow">
                          <td>
                            <LitStructuredText data={tableHeadingOne} basic />
                          </td>
                          <td>
                            {' '}
                            <LitStructuredText data={tableHeadingTwo} basic />
                          </td>
                        </tr>
                        {tables.map(({ key, value }) => {
                          return (
                            <tr>
                              <td className="table-column-one">
                                <LitStructuredText data={key} basic />
                              </td>
                              <td className="table-column-two">
                                {' '}
                                <LitStructuredText data={value} basic />
                              </td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  );
                },
              )}
            </div>
            <div className="image">
              <LitImage image={secondaryImage} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModularHeadingImageDropdownTableBox;
export const fragment = graphql`
  fragment ModularHeadingImageDropdownTableBox on DatoCmsHeadingImageDropdownTableBox {
    internal {
      type
    }
    heading {
      value
    }
    backgroundColor
    noTopPadding
    noBottomPadding

    dropdownBody {
      value
    }
    image {
      gatsbyImageData
    }
    secondaryImage {
      gatsbyImageData
    }
    tables {
      heading {
        value
      }
      tableHeadingOne {
        value
      }
      tableHeadingTwo {
        value
      }
      tables {
        key {
          value
        }
        value {
          value
        }
      }
    }
  }
`;
